import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import Table, {
    TableFooter,
    TablePagination,
    TableRow,
} from 'material-ui/Table';
import EnhancedTableToolbar from './EnhancedTableToolbar';
import EnhancedTableHead from './EnhancedTableHead';
import EnhancedTableBody from './EnhancedTableBody';
import SearchInput from 'react-search-input';

const styles = theme => ({
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
    },
    table: {
      minWidth: 800,
    },
    tableWrapper: {
      overflowX: 'auto',
    },
});

let EnhancedDataTable = props => {
    const { title,selected,order,orderBy,page,rowsPerPage,data,columnData,
        handleSelectAllClick,handleRequestSort,isSelectedFunc,handleClick,
        handleKeyDown,handleChangePage,handleChangeRowsPerPage,classes,
        customColFunc,tableStyle,translate,totalRows,
        handleSearch,clientUiProps,showToolbar,addNewOnclick
     } = props;
    
    return (
        <Paper className={classes.root}>
          
          {showToolbar?<EnhancedTableToolbar title={title} addNewOnclick={addNewOnclick} />:null} 
          
          <div className={classes.tableWrapper}>
            <Table className={classes.table} style={tableStyle} >
              <EnhancedTableHead
                //numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={totalRows}
                columnData={columnData}
                translate={translate}
              />
              <EnhancedTableBody 
                  data={data}
                  totalRows={totalRows}
                  columnData={columnData}
                  //isSelectedFunc={isSelectedFunc}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleClick={handleClick}
                  handleKeyDown={handleKeyDown}
                  customColFunc={customColFunc}
                  clientUiProps={clientUiProps}
              />
              <TableFooter>
                <TableRow>
                  <TablePagination
                    count={totalRows}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    labelRowsPerPage={translate?translate('rowsPerPage'):'Rows per page'}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </div>
        </Paper>
    );
}

EnhancedDataTable.propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    //selected: PropTypes.array.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    totalRows: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
    columnData: PropTypes.array.isRequired,
    handleSelectAllClick: PropTypes.func,
    handleRequestSort: PropTypes.func.isRequired,
   // isSelectedFunc: PropTypes.func.isRequired,
    handleClick: PropTypes.func,
    handleKeyDown: PropTypes.func,
    handleChangePage: PropTypes.func.isRequired,
    handleChangeRowsPerPage: PropTypes.func.isRequired,
    deleteOnClick: PropTypes.func,
    handleSearch: PropTypes.func.isRequired
};

EnhancedDataTable = withStyles(styles)(EnhancedDataTable);
export default EnhancedDataTable;


// WEBPACK FOOTER //
// ./src/components/MaterialUi/DataTable/EnhancedDataTable.js